import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=722123ec&scoped=true&"
import script from "./favorite.js?vue&type=script&lang=js&"
export * from "./favorite.js?vue&type=script&lang=js&"
import style0 from "./favorite.scss?vue&type=style&index=0&id=722123ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722123ec",
  null
  
)

export default component.exports